var cov_buuoua8m2 = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Form/index.ts",
      hash = "ec2aea18e751b3603755495c749233c4a79998c3",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Form/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 21,
          column: 51
        },
        end: {
          line: 21,
          column: 68
        }
      },
      "1": {
        start: {
          line: 22,
          column: 37
        },
        end: {
          line: 22,
          column: 65
        }
      },
      "2": {
        start: {
          line: 23,
          column: 69
        },
        end: {
          line: 29,
          column: 1
        }
      },
      "3": {
        start: {
          line: 30,
          column: 69
        },
        end: {
          line: 30,
          column: 82
        }
      },
      "4": {
        start: {
          line: 31,
          column: 19
        },
        end: {
          line: 34,
          column: 42
        }
      },
      "5": {
        start: {
          line: 35,
          column: 0
        },
        end: {
          line: 35,
          column: 66
        }
      },
      "6": {
        start: {
          line: 36,
          column: 0
        },
        end: {
          line: 36,
          column: 35
        }
      },
      "7": {
        start: {
          line: 37,
          column: 0
        },
        end: {
          line: 37,
          column: 66
        }
      },
      "8": {
        start: {
          line: 38,
          column: 0
        },
        end: {
          line: 38,
          column: 59
        }
      },
      "9": {
        start: {
          line: 40,
          column: 0
        },
        end: {
          line: 40,
          column: 40
        }
      },
      "10": {
        start: {
          line: 41,
          column: 0
        },
        end: {
          line: 41,
          column: 38
        }
      },
      "11": {
        start: {
          line: 42,
          column: 0
        },
        end: {
          line: 42,
          column: 40
        }
      },
      "12": {
        start: {
          line: 44,
          column: 0
        },
        end: {
          line: 44,
          column: 38
        }
      },
      "13": {
        start: {
          line: 45,
          column: 0
        },
        end: {
          line: 45,
          column: 28
        }
      },
      "14": {
        start: {
          line: 47,
          column: 0
        },
        end: {
          line: 47,
          column: 39
        }
      },
      "15": {
        start: {
          line: 48,
          column: 0
        },
        end: {
          line: 48,
          column: 48
        }
      },
      "16": {
        start: {
          line: 49,
          column: 0
        },
        end: {
          line: 49,
          column: 50
        }
      },
      "17": {
        start: {
          line: 50,
          column: 0
        },
        end: {
          line: 50,
          column: 48
        }
      },
      "18": {
        start: {
          line: 51,
          column: 0
        },
        end: {
          line: 51,
          column: 56
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import { compose } from '../utils/func';
import Datum from '../Datum';
import { consumer as cardConsumer } from '../Card/context';
import inputable from './inputable';
import Form from './Form';
import Item from './Item';
import Field from './Field';
import Flow from './Flow';
import FieldSet from './FieldSet';
import formButton from './formButton';
import { formProvider, formConsumer } from './formContext';
import useMode from './mode';
var formCardConsumerKey = (cov_buuoua8m2.s[0]++, ['setFormStatus']);
var formDatumKey = (cov_buuoua8m2.s[1]++, ['removeUndefined', 'error']);
var formItemWithFormConsumerKeys = (cov_buuoua8m2.s[2]++, ['formDatum', 'labelWidth', 'labelAlign', 'labelVerticalAlign', 'keepErrorHeight']);
var formFlowWithFormConsumerKeys = (cov_buuoua8m2.s[3]++, ['formDatum']);
var exportForm = (cov_buuoua8m2.s[4]++, compose(Datum.hoc({
  type: 'form',
  bindProps: formDatumKey
}), formProvider)(cardConsumer(Form, formCardConsumerKey)));
cov_buuoua8m2.s[5]++;
exportForm.Item = formConsumer(formItemWithFormConsumerKeys)(Item);
cov_buuoua8m2.s[6]++;
exportForm.Field = inputable(Field);
cov_buuoua8m2.s[7]++;
exportForm.Flow = formConsumer(formFlowWithFormConsumerKeys)(Flow);
cov_buuoua8m2.s[8]++;
exportForm.FieldSet = formConsumer(['formDatum'])(FieldSet);
cov_buuoua8m2.s[9]++;
exportForm.Submit = formButton('submit');
cov_buuoua8m2.s[10]++;
exportForm.Reset = formButton('reset');
cov_buuoua8m2.s[11]++;
exportForm.Button = formButton('button');
cov_buuoua8m2.s[12]++;
exportForm.formConsumer = formConsumer;
cov_buuoua8m2.s[13]++;
exportForm.useMode = useMode;
cov_buuoua8m2.s[14]++;
exportForm.displayName = 'ShineoutForm';
cov_buuoua8m2.s[15]++;
exportForm.Item.displayName = 'ShineoutFormItem';
cov_buuoua8m2.s[16]++;
exportForm.Field.displayName = 'ShineoutFormField';
cov_buuoua8m2.s[17]++;
exportForm.Flow.displayName = 'ShineoutFormFlow';
cov_buuoua8m2.s[18]++;
exportForm.FieldSet.displayName = 'ShineoutFormFieldSet';
export default exportForm;